import { useState } from "react";
// STYLES
import * as Style from "./InputAtomStyle";

// LIBRARIES
import moment from "moment";

// MISC
import { InputAtomTypes, IProps } from "./InputAtomModel";
import { InputTypes, ModalTypes } from "models/GeneralTypes/generalTypes";

// ASSETS
import PasswordHidden from "assets/Icons/PasswordHidden.svg";
import PasswordSee from "assets/Icons/PasswordSee.svg";
import MailIcon from "assets/Icons/MailIcon.svg";
import PasswordIcon from "assets/Icons/PasswordIcon.svg";
import MailIconActive from "assets/Icons/MailIconActive.svg";
import PasswordIconActive from "assets/Icons/PasswordIconActive.svg";
import SearchIcon from "assets/Icons/SearchIcon.svg";
import XIcon from "assets/Icons/XIcon.svg";

// REDUX
import { toggleChildModalState, toggleModalState } from "slices/uiSlice";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";

// COMPONENTS

const InputAtom = (props: IProps) => {
  // PROPS
  const {
    name = "",
    label = "",
    placeholder = "",
    type = "",
    inputValue = "",
    setInputValue = () => { },
    multiline = false,
    maxRows = 0,
  } = props;

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  // const startDateData = useAppSelector(startDate);

  // CONSTANTS USING HOOKS
  const [showPassword, setShowPassword] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleFocus = () => {
    setIsActive(true);
  };

  const handleBlur = () => {
    setIsActive(false);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const openCalendar = () => {
    // dispatch(toggleChildModalState({
    //   isVisible: true,
    //   type: ModalTypes.CALENDAR
    // }))
  }

  if (type === InputTypes.MODAL_INPUT) {
    return (
      <Style.InfoLine>
        <Style.Label>
          {label}
        </Style.Label>
        <Style.StyledInput
          disableUnderline
          value={inputValue}
          name={name}
          placeholder={placeholder}
          onChange={handleChange}
          type="text"
        />
      </Style.InfoLine>
    )
  } 
  // else if (type === InputTypes.DATE_INPUT) {
  //   return (
  //     <Style.InfoLine onClick={openCalendar}>
  //       <Style.Label>
  //         {label}
  //       </Style.Label>
  //       <Style.StyledInput
  //         disableUnderline
  //         value={startDateData ? moment(startDateData).format('DD/MM/YY') : inputValue}
  //         name={name}
  //         placeholder={placeholder}
  //         onChange={handleChange}
  //         type="text"
  //       />
  //     </Style.InfoLine>
  //   )
  // } 
  else return (
    <Style.InputAtom
      inputType={type}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus}
      onBlur={handleBlur}
      isActive={isActive}
      value={inputValue}
      name={name}
      placeholder={placeholder}
      onChange={handleChange}
      type={type === InputAtomTypes.PASSWORD ? (showPassword ? "text" : "password") : "text"}
      multiline={multiline}
      minRows={4}
      maxRows={maxRows}
      variant="standard"
      InputProps={{
        disableUnderline: true,
        endAdornment: (type === InputAtomTypes.PASSWORD || type === InputAtomTypes.SEARCH) && (
          type === InputAtomTypes.SEARCH ?
            <Style.SearchIconButton
              src={XIcon}
              onClick={() => setInputValue("")}
            /> :
            <Style.IconButton
              src={!showPassword ? PasswordHidden : PasswordSee}
              onClick={() => togglePasswordVisibility()}
            />
        ),
        startAdornment: (type === InputAtomTypes.SEARCH ?
          <Style.SearchIconButtonStart
            src={SearchIcon}
          />
          :
          <Style.IconButtonStart
            src={isHovered || isActive ?
              (type === InputAtomTypes.PASSWORD ? PasswordIconActive : MailIconActive) :
              (type === InputAtomTypes.PASSWORD ? PasswordIcon : MailIcon)}
          />
        ),
      }}
    />
  );
};

export default InputAtom;
